  <div v-if="showModal && token_exists">
    <div class="modal fade show" tabindex="-1" style="display:block;" aria-modal="true" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Inactivity Warning</h5>
          </div>
          <div class="modal-body">
            <div class="alert alert-warning d-flex align-items-center" role="alert">
                <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Warning:"><use xlink:href="#exclamation-triangle-fill"/></svg>
                <div>
                     You have been inactive for 30 minutes. Do you want to stay logged in?
                </div>
                </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary btn-sm text-xxs shadow-sm" @click="stayLoggedIn">Keep Me Logged In</button>
            <button class="btn btn-primary btn-sm shadow-sm text-xxs " @click="logout">Logout</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal backdrop -->
    <div class="modal-backdrop fade show"></div>
  </div>